module.exports = __webpack_public_path__ + "static/images/num-bg2.f79bcbe.png";